module.exports = __webpack_public_path__ + "static/media/18-19-AdmissionsPacket.9910158c.pdf";